import axios from 'axios';
const CancelToken = axios.CancelToken;
let cancel;
export default {
	cancelSuggestion() {
		if (cancel) {
			cancel();
		}
	},
	getSuggestions(input) {
		this.cancelSuggestion();
		return new Promise(async (resolve, reject) =>{
			try {
				const response = await axios.get('/public/location', {
					cancelToken: new CancelToken(c => {
						cancel = c;
					  }),
					params: {
						input
					}
				});
				resolve(response);
			} catch (err) {
				if (axios.isCancel(err)) {
					resolve();
				  } else {
					reject(err);
				  }
			}

		});
	},
	search(params) {
		let path = "search";
		let comissionIds = window.searchParams?.comissionIds;
		if (comissionIds) {
			path = "commission-search";
			params = {
				page: params.page,
				pageSize: params.pageSize,
				comissionIds: comissionIds.join(",")
			};
		}
		return axios.get(`/public/properties/${path}`, {
			params
		});
	}
};